<script lang="ts">
	import AccountNav from "./AccountNav.svelte"
	import { ACCOUNT_ROUTES, AccountNavigator } from "./AccountStore"
	import { pageLoader } from "../../../modules/auth/onUserLogin"
	import { Toast } from "toaster"
	import { onMount } from "svelte"
	import { getSubscriptionManager } from "../../../modules/subscription-management/SubscriptionManager.svelte"

	let activeRoute: keyof typeof ACCOUNT_ROUTES = $state()

	AccountNavigator.subscribe(({ route }) => {
		activeRoute = route
	})

	async function logoutUser() {
		await pageLoader.onUserLogout()
		Toast.success("Successfully logged out. Redirecting to login page...")
		location.replace("/login")
	}

	const SvelteComponent = $derived(ACCOUNT_ROUTES[activeRoute])

	onMount(() => {
		const subscriptionManager = getSubscriptionManager()
		subscriptionManager.refreshUserSubscriptions()
	})
</script>

<div id="account-overlay">
	<menu id="overlay-sidemenu">
		<span class="flex-row">
			<h3>Account</h3>
			<button id="logout-button" class="link-button small" onclick={logoutUser}>Logout</button>
		</span>
		<AccountNav />
	</menu>
	<div class="open-account-menu">
		<SvelteComponent />
	</div>
</div>

<style>
	#account-overlay {
		/* width: 100%; */
		height: 100%;
		width: 51rem;
		min-height: 34rem;
		background: var(--color-bg-gradient);
		display: flex;
		flex-direction: row;
	}

	:global(.isMobile) #account-overlay {
		flex-direction: column;
		width: calc(95dvw - 2rem);
		height: calc(95dvh - 2rem);
	}

	#overlay-sidemenu .flex-row {
		justify-content: space-between;
		align-items: flex-end;
	}

	:global(.isMobile) #overlay-sidemenu .flex-row {
		justify-content: flex-start;
	}

	#overlay-sidemenu h3 {
		font-size: var(--h1);
		margin: 0;
	}

	#overlay-sidemenu {
		padding: 1rem 0 1rem 2rem;
		width: 14rem;
		position: relative;
	}

	:global(.isMobile) #overlay-sidemenu {
		width: unset;
		padding: 1rem 1rem 0 1rem;
	}

	#logout-button {
		color: var(--color-text);
	}

	#logout-button:hover,
	#logout-button:focus-visible {
		color: var(--color-main);
	}

	.open-account-menu {
		background-color: var(--color-bg);
		flex: 1;
		padding: 3rem 2rem 1rem 2rem;
		overflow-y: auto;
	}

	.open-account-menu :global(.input-container) {
		flex-direction: column;
	}

	.open-account-menu :global(.input-container label) {
		width: 100%;
		text-align: left;
		font-size: var(--h3);
		color: var(--color-text);
		margin-bottom: 0.25rem;
		margin-left: 1rem;
	}

	.open-account-menu :global(.input-container input) {
		width: 14.5rem;
	}

	.open-account-menu :global(.input-container > input) {
		width: 16rem;
	}

	.open-account-menu :global(h3) {
		font-size: var(--h2);
		margin: 0 0 1rem 0;
	}

	.open-account-menu :global(.subscription-container) {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	:global(.isMobile) .open-account-menu {
		padding: 1rem;
	}

	:global(.isMobile) .open-account-menu:has(:global(.bottom-buttons)) {
		margin-bottom: 3.5rem;
	}

	:global(.isMobile) #account-overlay :global(.input-container) {
		width: 100%;
	}

	:global(.isMobile) .open-account-menu :global(.input-container input) {
		width: 100%;
	}
</style>
